
<span *ngIf="lndUserType">
    <app-header-global></app-header-global>
</span>
<div class="row allcontent">
    <div [ngClass]="sidebarCollapsed ? 'col-sm-1' : 'col-sm-2'">
        <app-side-overlay-menu></app-side-overlay-menu>
     </div>
    <div [ngClass]="sidebarCollapsed ? 'col-sm-11' : 'col-sm-10'" class="contentsection">
        <div *ngIf="lndUserType" class="row p1rem  fix_header">
            <p class="custom_heading">Circulars & Videos</p>
        </div>
        
        <!-- Tabs Navigation -->
        <div class="wrapper margin__top">
            <ul class="nav nav-tabs" id="circularTabs" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link active" id="circulars-tab" data-bs-toggle="tab" data-bs-target="#circulars" type="button" role="tab" aria-controls="circulars" aria-selected="true">
                        Circulars
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="videos-tab" data-bs-toggle="tab" data-bs-target="#videos" type="button" role="tab" aria-controls="videos" aria-selected="false">
                        Videos
                    </button>
                </li>
            </ul>
            
            <!-- Tabs Content -->
            <div class="tab-content" id="circularTabsContent">
                <!-- Circulars Tab -->
                <div class="tab-pane fade show active" id="circulars" role="tabpanel" aria-labelledby="circulars-tab">
                    <div class="wrapper">
            <div *ngFor="let document of documents">
                <div class="row">
                    <div class="col">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col">
                                        <div class="row">
                                            <div class="col text-heading">
                                                <strong>{{document.title}} </strong>  
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col text-decor">
                                                {{document.description}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="row">
                                            <div class="col p5 view-btn">
                                                <button type="button" class="btn btn-outline-primary" (click)="viewDownloadPdf(document.file)">Download</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                    </div>
                </div>
                
                <!-- Videos Tab -->
                <div class="tab-pane fade" id="videos" role="tabpanel" aria-labelledby="videos-tab">
                    <div class="wrapper">
                        <div class="row mt-4">
                            <div class="col-md-6">
                                <div class="card">
                                    <div class="card-body">
                                        <h5 class="card-title mb-3">Demo</h5>
                                        <div class="ratio ratio-16x9">
                                            <video controls style="width: 100%; height: 100%;">
                                                <source src="https://tinyurl.com/5ej96jp8" type="video/mp4">
                                                Your browser does not support the video tag.
                                            </video>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card">
                                    <div class="card-body">
                                        <h5 class="card-title mb-3">Guidelines</h5>
                                        <div class="ratio ratio-16x9">
                                              <video controls style="width: 100%; height: 100%;">
                                                <source src="https://tinyurl.com/ra774utp" type="video/mp4">
                                                Your browser does not support the video tag.
                                            </video>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                
            </div>
        </div>
        
    </div>
</div>